export default "__VITE_ASSET__9547f43b__"